import { CypherpunkProvider } from '../context/CypherpunkContext';
import { Navigation } from '../components/Navigation';
import { HeroSection } from '../components/HeroSection';
import { AboutSection } from '../components/AboutSection';
import { NakamotoSection } from '../components/NakamotoSection';
import { GallerySection } from '../components/GallerySection';
import { PhilosophySection } from '../components/PhilosophySection';
import { PrivateMoneySection } from '../components/PrivateMoneySection';
import { TransmissionsSection } from '../components/TransmissionsSection';
import { DropsSection } from '../components/DropsSection';
import { ContactSection } from '../components/ContactSection';
import { SupportSection } from '../components/SupportSection';
import { Footer } from '../components/Footer';
import { CypherpunkCursor } from '../components/CypherpunkCursor';

export default function LegacyHomepage() {
  return (
    <CypherpunkProvider>
      <CypherpunkCursor />
      <div className="app-root" data-testid="app-root">
        <Navigation />
        <main>
          <HeroSection />
          <AboutSection />
          <NakamotoSection />
          <GallerySection />
          <PhilosophySection />
          <PrivateMoneySection />
          <TransmissionsSection />
          <DropsSection />
          <ContactSection />
          <SupportSection />
        </main>
        <Footer />
      </div>
    </CypherpunkProvider>
  );
}
